import React from 'react'
import { CreateAccount } from '../../components/create-account/create-account'

export default function Index() {
  return <CreateAccount />
}
